import { render } from "./CustomIconButton.vue?vue&type=template&id=41d63f58&scoped=true"
import script from "./CustomIconButton.vue?vue&type=script&lang=js"
export * from "./CustomIconButton.vue?vue&type=script&lang=js"

import "./CustomIconButton.vue?vue&type=style&index=0&id=41d63f58&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d63f58"]])

export default __exports__